import request from '@/utils/request'

/**
 * 渠道列表
 * 地址: http://doc.pharmconverge.com/index.php?s=/22&page_id=924
 */
export function channelList(params) {
  return request({
    url: '/qudao/get-list',
    method: 'post',
    data: params
  })
}

/** 渠道管理  增加基本信息接口
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=921
 */
export function channelAdd(params) {
  return request({
    url: '/qudao/add-info',
    method: 'post',
    data: params,
    formData: true
  })
}

/**
 * 渠道详情-列表
 * 地址 http://doc.pharmconverge.com/index.php?s=/22&page_id=922
 */

export function channelEditInfo(params) {
  return request({
    url: '/qudao/get-info',
    method: 'post',
    data: params
  })
}

/**
 * 渠道编辑保存
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=923
 */
export function saveChannelEdit(params) {
  return request({
    url: '/qudao/edit-info',
    method: 'post',
    data: params,
    formData: true
  })
}

/**
 * 渠道新增获取uuid
 * 地址:  http://doc.pharmconverge.com/index.php?s=/22&page_id=925
 */
export function getChannelUuid() {
  return request({
    url: '/qudao/get-url-and-uuid',
    method: 'post',
    data: {}
  })
}

/**
 * 获取渠道下拉筛选项
 * 地址:
 */
export function getChannelOpts() {
  return request({
    url: '/qudao/get-qu-dao-use-for-filter',
    method: 'post',
    data: {}
  })
}
